import React from "react";
import configData from '../../config/config.json';
import './index.css';
import Modal from 'react-responsive-modal';
import { withTranslation } from 'react-i18next';

class Banner extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            open_promotion: false
        }
    }

    showPromotionModal = (event, open) => {
        if (event)
            event.stopPropagation()

        //console.log(open)
        this.setState({ 
            open_promotion: open,
            open: false
         });
    };

    render() {
        const { t } = this.props;
        /*
        if (this.props?.campaign==='crazyweekend') {
                
            return (
                <>
                    <div style={{maxWidth:'90%',margin:'1em auto 2em'}} className={this.props?.hide?'hide':'mobile-only'} onClick={(e)=> this.showPromotionModal(e,true)}>
                        <img src="/images/promotions/crazyweekend/banner.jpg" width="100%" alt={t('category.banners.campaigns.crazyweekend.imageAlt')} />
                    </div>
                    <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                        <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                            <p><br /><strong>{t('promotions.campaigns.crazyweekend.modal.title')}</strong><br /><br />
                            {t('promotions.campaigns.crazyweekend.modal.intro')}
                            </p>

                            <p>{t("promotions.campaigns.crazyweekend.modal.description")}</p>
                            <p>{t("promotions.campaigns.crazyweekend.modal.instructions")}</p>
                            <p>{t("promotions.campaigns.crazyweekend.modal.terms")}</p>

                        </div>
                    </Modal>
                </>
            )    
        } else if (this.props?.campaign==='weekend30') {
            return (
                <>
                    <div style={{maxWidth:'90%',margin:'1em auto 2em'}} className={this.props?.hide?'hide':'mobile-only'} onClick={(e)=> this.showPromotionModal(e,true)}>
                        <img src="/images/promotions/weekend30/1200x628-weekend-website-mobile.png" width="100%" alt={t('category.banners.campaigns.weekend30.imageAlt')} />
                    </div>
                    <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                    <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                        <p><br /><strong>{t('promotions.campaigns.weekend30.modal.title')}</strong><br /><br />
                        {t('promotions.campaigns.weekend30.modal.intro')}
                        </p>

                        <p>{t("promotions.campaigns.weekend30.modal.description")}</p>
                        <p>{t("promotions.campaigns.weekend30.modal.instructions")}</p>
                        <p>{t("promotions.campaigns.weekend30.modal.terms")}</p>

                    </div>
                    </Modal>
                </>
            )
        } else if (this.props?.campaign==='rosh25') {
            return (
                <>
                    <div style={{maxWidth:'90%',margin:'1em auto 2em'}} className={this.props?.hide?'hide':'mobile-only'} onClick={(e)=> this.showPromotionModal(e,true)}>
                        <img src="/images/promotions/rosh25/1200x628-website-mobile.png" width="100%" alt={t('category.banners.campaigns.rosh25.imageAlt')} />
                    </div>
                    <Modal open={this.state.open_promotion} onClose={(e) => this.showPromotionModal(e,false)} center >
                    <div dir="rtl"  className="modal_content" style={{color:'#000', fontWeight:'600'}}>
                    <p><br /><strong>{t('promotions.campaigns.rosh25.modal.title')}</strong><br />
                                    </p>

                        <p>{t("promotions.campaigns.rosh25.modal.description")}</p>
                        <p>{t("promotions.campaigns.rosh25.modal.instructions")}</p>
                        <p>{t("promotions.campaigns.rosh25.modal.terms")}</p>

                    </div>
                    </Modal>
                </>
            )
        }
        else {
            return (<></>)
        }
        */

        return(<></>)
    }
}
export default withTranslation()(Banner);